import { useRef } from "react";
import { Camera, Upload } from "lucide-react";
import { Button } from "./button";

function isUnsupportedIosBrowser() {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  return /iPad|iPhone|iPod/.test(ua) && /(CriOS|FxiOS|EdgiOS)/.test(ua);
}

/**
 * Due azioni esplicite per il picker nativo: file generico o fotocamera posteriore.
 * Safari/iPad gestisce capture affidabilmente; sugli altri browser iOS viene mostrato un avviso.
 */
export default function FilePickerButton({
  accept = "image/*",
  onChange,
  disabled = false,
  className = "",
  fileLabel = "Carica file",
  photoLabel = "Scatta foto",
}) {
  const fileRef = useRef(null);
  const cameraRef = useRef(null);
  const chooseCamera = () => {
    if (isUnsupportedIosBrowser()) {
      window.alert("Su iPad la fotocamera può non funzionare correttamente in Chrome. Apri Affidya con Safari e riprova.");
      return;
    }
    cameraRef.current?.click();
  };

  return (
    <div className={`flex flex-wrap justify-center gap-2 ${className}`}>
      <input ref={fileRef} type="file" accept={accept} onChange={onChange} className="hidden" disabled={disabled} />
      <input ref={cameraRef} type="file" accept="image/*" capture="environment" onChange={onChange} className="hidden" disabled={disabled} />
      <Button type="button" variant="outline" onClick={() => fileRef.current?.click()} disabled={disabled}>
        <Upload className="w-4 h-4 mr-1.5" />{fileLabel}
      </Button>
      <Button type="button" variant="outline" onClick={chooseCamera} disabled={disabled}>
        <Camera className="w-4 h-4 mr-1.5" />{photoLabel}
      </Button>
    </div>
  );
}
